const TestPageActionTypes = {
  FETCH_TEST_START: 'FETCH_TEST_START',
  FETCH_TEST_SUCCESS: 'FETCH_TEST_SUCCESS',
  FETCH_TEST_FAILURE: 'FETCH_TEST_FAILURE',
  SUBMIT_TEST_START: 'SUBMIT_TEST_START',
  SUBMIT_TEST_SUCCESS: 'SUBMIT_TEST_SUCCESS',
  SUBMIT_TEST_FAILURE: 'SUBMIT_TEST_FAILURE',
  RESET_TEST_INFO: 'RESET_TEST_INFO',
};

export default TestPageActionTypes;
